import { isNull, isUndefined } from 'lodash';

/**
 * Return true if the value is null or undefined
 */
export const isNullOrUndefined = (value: unknown) => {
  return isNull(value) || isUndefined(value);
};
